export default function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center h-screen bg-[var(--bg)]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-[var(--border)] border-t-[var(--gold)] rounded-full animate-spin" />
        <p className="text-[var(--muted)] text-sm">Carregando...</p>
      </div>
    </div>
  );
}
